module.exports = __webpack_public_path__ + "static/media/poi.57ad1c75.png";